import  {
  getConfig
} from '../api'

export default {
  //弹框
  showPopup({ commit }, popupName) {
    commit('SHOWPOPUP', popupName)
  },
  hidePopup({ commit }, popupName) {
    commit('HIDEPOPUP', popupName)
  },

  setUserInfo({ commit }, userInfo) {
    commit('USERINFO', userInfo)
  },

  getSignPath({ commit }, path) {
    commit('GETPATH', path)
  },

  showCatlogue({ commit }, isShow) {
    commit('SHOWCTALOGUE', isShow)
  },
  getMatchInfo({ commit }, info) {
    commit('GET_MATCHINFO', info)
  },
  getctalogueInfo({ commit }, info) {
    commit('GET_CTALOGUEINFO', info)
  },
  //
  // getWorkDatas({commit},datas){
  //   commit('WORKDATAS',datas)
  // }

  //比赛标题
  getMatchTitle({ commit }, title) {
    commit('MATCHTITLE', title)
  },

  //配置
  async getConfigs({commit},keys){
    let res = await getConfig(keys)
    if(res.resultType == 0){
      commit('GET_CONFIGS',res.appendData)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js